import { render, staticRenderFns } from "./LandingSectionPlayList.vue?vue&type=template&id=012177ec&scoped=true&"
import script from "./LandingSectionPlayList.vue?vue&type=script&lang=js&"
export * from "./LandingSectionPlayList.vue?vue&type=script&lang=js&"
import style0 from "./LandingSectionPlayList.vue?vue&type=style&index=0&id=012177ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012177ec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingText: require('/home/circleci/repo/components/landing/elements/LandingText.vue').default,LandingVideo: require('/home/circleci/repo/components/landing/elements/LandingVideo.vue').default})
